export default "__VITE_ASSET__D0Y0$NVB__"